import { DateTime } from 'luxon';
import {
  downloadCSV,
  escapeDangerousCSVCharacters,
  replaceDoubleQuoteInString,
} from '../../../../../common/functions/csv-utils';
import { PendingRequestRow, getRequestDate, getVolunteerName } from './pending-requests-types';

const toCsvLine = (values: string[]) =>
  `"${values.map((value) => escapeDangerousCSVCharacters(replaceDoubleQuoteInString(value))).join('","')}"`;

export const downloadPendingRequestsCsv = (rows: PendingRequestRow[], dateHeader: string, filePrefix: string) => {
  const header = toCsvLine(['Volunteer', 'Program', 'Activity', dateHeader, 'Email', 'Contact Number', 'Responses']);
  const lines = rows.map((row) =>
    toCsvLine([
      getVolunteerName(row),
      row.programName,
      row.activityName,
      getRequestDate(row).toFormat('dd/MM/y'),
      row.email,
      row.contactNumber,
      row.answers.map((answer) => `${answer.label}: ${answer.answer}`).join(' | '),
    ])
  );
  downloadCSV([header, ...lines].join('\r\n'), `${filePrefix}_${DateTime.local().toFormat('yyyy-MM-dd')}.csv`);
};
